import { render } from "./confirmPay.vue?vue&type=template&id=cba9f152&scoped=true"
import script from "./confirmPay.vue?vue&type=script&lang=js"
export * from "./confirmPay.vue?vue&type=script&lang=js"

import "./confirmPay.vue?vue&type=style&index=0&id=cba9f152&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba9f152"]])

export default __exports__